import { render, staticRenderFns } from "./hh2.vue?vue&type=template&id=cfdc1cd4&scoped=true"
import script from "./hh2.vue?vue&type=script&lang=js"
export * from "./hh2.vue?vue&type=script&lang=js"
import style0 from "./hh2.vue?vue&type=style&index=0&id=cfdc1cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdc1cd4",
  null
  
)

export default component.exports